<template>
  <div>
    <div class="exchange_header">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="积分兑换" name="first"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="exchange_content"></div>
  </div>
</template>

<script>
export default {
  name: "Exchange",
  data() {
    return {
      activeName: "first",
    };
  },
  mounted() {
    this.$store.commit("setNavLeft", 4);
  },
  methods: {
  }
};
</script>

<style>
.exchange_header {
  width: 974px;
}
.exchange_header .el-tabs__item {
  font-size: 26px;
  margin-bottom: 10px;
  color: #636363;
}
.exchange_header .el-tabs__item.is-active {
  color: #55b233;
}
.exchange_header .el-tabs__active-bar {
  background-color: #55b233;
}
.exchange_header .el-tabs__item:hover {
  color: #55b233 !important;
}
.exchange_content{
  height: 640px;
  width: 1000px;
  overflow:hidden;
  padding-right: 50px;
  background: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/views/my/Exchange.vue